module.exports = __webpack_public_path__ + "img/74ne.a8560262.svg";